// eslint-disable-next-line
import React, { useRef, useEffect } from 'react';
import ContentEditable from 'react-contenteditable';

import './EditableTableHeader.scss';

import { useShortKeysNavigation } from '../../../hooks/useShortKeysNavigation';

const TABLE_HEADER_HEIGHT = 40;

const EditableTableHeader = ({
    tableX = 0,
    tableY = 0,
    tableWidth = 0,
    scale,
    originXY,

    elementId,
    insideElementId,

    name,
    handleHeaderNameChange,
    handleFocusOnFirstColumn,
    // handleAddNewFirstColumn,
    // handleDeleteElements,
}) => {
    const { isMac } = useShortKeysNavigation();

    const fieldNameRef = useRef(null);
    const focusedFieldRef = useRef(null);

    const sanitizeInput = (val) => (
        (val || '')
            .replace(/<\/?[^>]+(>|$)/g, '')
            .replace(/&[a-zA-Z0-9#]{2,10};/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim()
    );

    const onNameChange = (event) => {
        if (event.nativeEvent.inputType !== 'insertParagraph') {
            let nameValue = sanitizeInput(event.target.value);
            // const newWidth = customRecalcWidths(nameValue, type);

            console.log('namename___', event.target.value, typeof nameValue)
            // if (!nameValue) {
            //     nameValue = 'untitled';
            // }
            handleHeaderNameChange(nameValue);
        } else {
            event.nativeEvent.preventDefault();
        }
    };

    useEffect(() => {
        focusedFieldRef.current = 'name';
        focusNameField();

        return () => { };
    }, [elementId, insideElementId]);

    const focusNameField = () => {
        if (fieldNameRef.current) {
            // Автофокус на елементі
            fieldNameRef.current.focus();

            // Виділення всього тексту
            const range = document.createRange();
            const selection = window.getSelection();
            range.selectNodeContents(fieldNameRef.current);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    const handleKeyDown = (event) => {
        const isCtrl = isMac ? event.metaKey : event.ctrlKey;

        // Ignore events from disabled or read-only elements
        if (event.target.disabled || event.target.readOnly) return;

        // -----------------------------------------------------------------------------
        // + [TAB] = [INTERNAL] [FOCUS ON HEADER NAME FIELD]
        if (
            event.code === 'Tab' &&
            !event.ctrlKey &&
            !event.metaKey &&
            !event.altKey
        ) {
            event.preventDefault();
            focusedFieldRef.current = 'name';
            focusNameField();
        }

        // -----------------------------------------------------------------------------
        // + [ENTER] = [FOCUS ON FIRST COLUMN / ADD NEW FIRST COLUMN]
        // else if ((event.code === 'Enter' || event.code === 'NumpadEnter') &&
        // 	!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        // 	event.preventDefault();
        // 	event.stopPropagation();
        // 	handleAddNewFirstColumn(elementId, true);
        // }
        // // + [CTRL + ENTER] = [ADD NEW FIRST COLUMN]
        // else if ((event.code === 'Enter' || event.code === 'NumpadEnter') &&
        // 	isCtrl && !event.altKey) {
        // 	event.preventDefault();
        // 	handleAddNewFirstColumn(elementId, false);
        // }

        // -----------------------------------------------------------------------------
        // - [CTRL + DOWN] = [FOCUS ON FIRST COLUMN]
        else if (
            event.code === 'ArrowDown' &&
            isCtrl &&
            !event.shiftKey &&
            !event.altKey
        ) {
            event.preventDefault();
            handleFocusOnFirstColumn(elementId);
        }
        // + [CTRL + UP] = [INTERNAL] [FOCUS ON COLUMN ABOVE]
        else if (
            event.code === 'ArrowUp' &&
            isCtrl &&
            !event.shiftKey &&
            !event.altKey
        ) {
            event.preventDefault();
            focusedFieldRef.current = 'name';
            focusNameField();
        }

        // // -----------------------------------------------------------------------------
        // // +/- [CTRL + DELETE] = [NOW => DELETE ELEMENT] [SHOULD BE => OPEN DELETE CONTEXT MENU]
        // else if (event.code === 'Delete' &&
        // 	isCtrl && !event.shiftKey && !event.altKey) {
        // 	event.preventDefault();
        // 	handleDeleteElements();
        // }
        // -----------------------------------------------------------------------------
    };

    const columnY = 0;

    let columnStyles = {
        position: 'absolute',
        // left: `${tableX * scale + originXY.x + 45 * scale}px`,
        // top: `${(tableY + columnY + 1.4) * scale + originXY.y}px`,
        left: `${tableX * scale + originXY.x + 44 * scale}px`,
        top: `${(tableY + columnY + 1.6) * scale + originXY.y}px`,

        width: `${tableWidth * scale - 90 * scale}px`,
        height: `${TABLE_HEADER_HEIGHT * scale}px`,
    };

    let columnNameStyles = {
        position: 'absolute',
        top: `${(-9 / 5 + 4 + 1 + 1.8 + 0.3 + 0.1) * scale}px`,
        left: `${(0.9) * scale}px`,

        // width: `${tableWidth * scale / 2 - 15}px`,
        width: `100%`,
        height: `${(36 - 8 - 2) * scale}px`,

        lineHeight: `${(36 - 8 - 2) * scale}px`,

        fontFamily: "Inter, sans-serif",
        fontSize: `${20 * scale}px`,
        // fontWeight: 500,
        fontWeight: 600,
        textAlign: 'center',
        // color: '#b8c1c8',
        color: 'rgba(199, 215, 222, 1)',
        color: 'rgba(205, 218, 224, 1)',
        color: 'rgba(201, 217, 220, 1)',
        outline: 'none',
    };

    return (
        <div className={`editable-column focused`} style={columnStyles}>
            <ContentEditable
                innerRef={fieldNameRef}
                style={columnNameStyles}
                className={`editable-column-field header`}
                spellCheck="false"
                html={name}
                onChange={(event) => {
                    onNameChange(event);
                }}
                onKeyDown={(event) => {
                    handleKeyDown(event);
                }}
            />
        </div>
    );
};

export default EditableTableHeader;
